export default __webpack_public_path__ + "static/media/default.b4c2b47f.svg";